module.exports = __webpack_public_path__ + "static/media/GoalStar.724c004d.svg";